import React from "react";

const learningData = [
  {
    id: 1,
    source: "ICT academy",
    time: "3 oy",
    view:
      "https://www.google.com/maps/place/ICT+ACADEMY/@41.3542305,69.2886623,15z/data=!4m2!3m1!1s0x0:0x84660e201e025d7a?sa=X&ved=2ahUKEwj_xKmsypTuAhWFzqQKHW0XCucQ_BIwG3oECCkQAw",
    info: "I learned html, css, bootstrap, jquery, javascript",
  },
  {
    id: 2,
    source: "Udemy React Lessons",
    time: "2 weeks",
    view:
      "https://freecoursesdownload.com/react-tutorial-and-projects-course-21/",
    info:
      "I learned react, react hooks and other useful things. This lessons are entry for entering react world, I adviced for everyone to finish this courses",
  },
  {
    id: 3,
    source: "Codevolution(Youtube Channel)",
    time: "1 week",
    view:
      "https://www.youtube.com/watch?v=QFaFIcGhPoM&list=PLC3y8-rFHvwgg3vaYJgHGnModB54rxOk3",
    info:
      "I learned many things in react and redux this tutorial and I consolidated my react knowledge",
  },
  {
    id: 4,
    source: "The Net Ninja(Youtube Channel)",
    time: "1 week",
    view:
      "https://www.youtube.com/watch?v=OxIDLw0M-m0&list=PL4cUxeGkcC9ij8CfkAY2RAGb-tmkNwQHG",
    info:
      "I learned many things in react and redux this tutorial and I consolidated my react knowledge",
  },
  {
    id: 5,
    source: "React projects(search youtube)",
    time: "1 oy",
    view: "https://www.youtube.com/watch?v=iP_HqoCuRI0&t=29s",
    info:
      "I think that doing projects is the best learning, so before I begin to learn any programming lanuage even though I don't understand I try to make a project in the programming languages",
  },
  {
    id: 6,
    source: "PDP IT academy",
    time: "1.5 oy",
    view:
      "https://www.google.com/maps/place/PDP+IT-Academy/@41.3237765,69.241989,15z/data=!4m5!3m4!1s0x0:0xf9e01b5d45fc68cd!8m2!3d41.3237765!4d69.241989",
    info: "I learned redux and I consolidated my react knowledge",
  },
];

const workData = [
  {
    id: 1,
    company: "Texmart.uz",
    time: "Sep - November",
    view: "http://texmart.uz/",
    info:
      "I started to go to this company for increasing experience and did some projects in the greatest programmers'control",
  },
  {
    id: 2,
    company: "Umdsoft.uz",
    time: "November - January",
    view: "http://www.umdsoft.uz/",
    info:
      "I went to this company for increasing my experience and Umid brother who is the leader of this company gave me to do 'Windows.uz' site and I finished to do FrontEnd part of this site",
  },
  {
    id: 3,
    company: "World Bridge Academy",
    time: "Sep - Jan",
    view:
      "https://www.google.com/maps/place/%22World+Bridge+Academy%22/@41.3776322,69.304147,15z/data=!4m5!3m4!1s0x0:0x4edf2b1dcb5332c5!8m2!3d41.3776322!4d69.304147",
    info:
      "I worked as the teacher for earning enough money in order to learn web programming and I teached pupils in math",
  },
];

function Experience() {
  return (
    <div className="experience">
      <div className="commonBox" style={{ marginTop: "50px" }}>
        <h1>Working experience</h1>
        <div className="common"></div>
      </div>
      <div className="workExp">
        {workData.map((item) => (
          <div key={item.id} data-aos="fade-up" className="itemData">
            <div>
              <h3>{item.company}</h3>
              <p className="time">{item.time}</p>
              <p>{item.info}</p>
              <a href={item.view} className="btn btn1">
                View
              </a>
            </div>
          </div>
        ))}
      </div>
      <div className="commonBox">
        <h1>Learning experience</h1>
        <div className="common"></div>
      </div>
      <div className="learningExp">
        {learningData.map((item) => (
          <div key={item.id} className="itemData" data-aos="fade-up">
            <div>
              <h3>{item.source}</h3>
              <p className="time">{item.time}</p>
              <p>{item.info}</p>
              <a href="/" className="btn btn1">
                View
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Experience;
